import { SVGProps, Ref, forwardRef } from 'react';

export const MoonStarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M4.708 1.124C7.394-.357 6.328 1 6.016 3.09c-.619 4.137 2.758 7.512 6.894 6.894 2.09-.312 3.447-1.378 1.966 1.307-1.346 2.44-3.816 4.21-6.792 4.21A7.584 7.584 0 0 1 .5 7.915c0-2.975 1.768-5.446 4.208-6.792"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MoonStarFilledSize16Glyph.displayName = 'MoonStarFilledSize16Glyph';
